// Configures Sentry for the browser. Turbopack builds load ONLY this file for
// client-side instrumentation — sentry.client.config.ts is never bundled.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
//
// No replayIntegration: session replay records the page (even masked, it
// captures layout/structure of the user's transcript and notes), which
// contradicts the zero-storage promise in the privacy policy. Error reports
// carry stack traces and browser info only.

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.5";import * as Sentry from "@sentry/nextjs";
import { getSharedSentryOptions } from "@/lib/sentry/shared-options";

Sentry.init(getSharedSentryOptions());

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
